<div class="section">
    <div class="container">


        <div class="row">
            <div class="col-md-4 col-sm-6 ml-auto mr-auto">
                <div class="card card-register">
                    <h3 class="card-title">Reset Password</h3>
                    <form class="register-form">
                        <label>New Password</label>
                        <input [(ngModel)]="password_new" name="password_new" type="text" class="form-control"
                            placeholder="" value="" [ngModelOptions]="{standalone: true}"
                            (input)="password_new_change($event)">
                        <label>Repeat Password</label>
                        <input [(ngModel)]="password_new_repeat" name="password_new_repeat" type="text"
                            class="form-control" placeholder="" value="" [ngModelOptions]="{standalone: true}"
                            (input)="password_new_repeat_change($event)">

                        <label>One Time Pin (OTP)</label>
                        <input [(ngModel)]="one_time_pin" name="one_time_pin" type="text" class="form-control"
                            placeholder="" value="" [ngModelOptions]="{standalone: true}">



                        <button class="btn btn-danger btn-block btn-round mb-3"
                            (click)="reset_password($event)">Submit</button>

                        <p>Please note password change may take up to 5 minutes to update accross the system.</p>


                        <label class="text-danger">{{
                            result_message }}</label>
                    </form>

                </div>
            </div>

            <div class="col-md-6 col-sm-6 ml-auto mr-auto">
                <h4 class="title">
                    <small>Downloads</small>
                </h4>
                <div class="table-responsive mt-2">
                    <table class="table">

                        <tbody>
                            <tr *ngFor="let row of Data">

                                <td>{{row.name}}</td>
                                <td> <a class="btn btn-sm btn-success" (click)="downloadFile(row._id, row.filename, row.mimetype, row.filepath)"><i
                                            class="nc-icon nc-cloud-download-93"></i>
                                        Download</a></td>


                            </tr>

                            <tr class="w-100">

                                <td class="w-75">Lotus Notes Traveler</td>
                                <td> <a class="btn btn-sm btn-info" href="https://mail1.e-md.co.za/servlet/traveler"
                                        target="_blank"> <i class="nc-icon nc-app"></i> Install </a></td>


                            </tr>
                        </tbody>
                    </table>
                </div>

                Contact us on 0860 018 363 for any support enquiry.


            </div>





        </div>

    </div>
</div>